import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CanWriteDirective } from './can-write.directive'
import { CheckRoleDirective } from './check-role.directive'
import { EmbedSizeDirective } from './embed-size.directive'
import { ImageUploadDirective } from './image-upload.directive'
import { IsDevDirective } from './is-dev.directive'

@NgModule({
  imports: [
    CommonModule,
    CheckRoleDirective,
    CanWriteDirective,
    EmbedSizeDirective,
    ImageUploadDirective,
    IsDevDirective
  ],
  exports: [
    CheckRoleDirective,
    CanWriteDirective,
    EmbedSizeDirective,
    ImageUploadDirective,
    IsDevDirective
  ]
})
export class DirectivesModule {
}
